$(function () {
  if ($('.transfer-print-lists-page').length === 0) return;

  $('.transfer-print-filter-card .select2-default-all').select2({
    width: '100%',
    theme: 'bootstrap',
    allowClear: false,
    language: { noResults: function () { return '見つかりません。'; } },
  });

  function selectedChecks() {
    return $('.tpl-item-check:checked:not(:disabled)');
  }

  function interactiveChecks() {
    return $('.tpl-item-check:not(:disabled)');
  }

  function updateActionButtons() {
    var hasChecked = selectedChecks().length > 0;
    $('#tpl-change-source-btn, #tpl-change-date-btn, #tpl-complete-btn, #tpl-print-btn')
      .prop('disabled', !hasChecked);
  }

  function updateTotalAmount() {
    var total = 0;
    selectedChecks().each(function () {
      var amount = parseFloat($(this).closest('.tpl-body-row').data('amount')) || 0;
      total += amount;
    });
    var $display = $('#tpl-total-amount-display');
    if ($display.length) {
      // If nothing checked, show full total (server-rendered value stays)
      if (selectedChecks().length === 0) {
        $display.text($display.data('full-total') || $display.text());
      } else {
        if (!$display.data('full-total')) {
          $display.data('full-total', $display.text());
        }
        $display.text(total.toLocaleString('ja-JP') + '円');
      }
    }
  }

  function updateCheckAll() {
    var $checks = interactiveChecks();
    var allChecked = $checks.length > 0 && $checks.length === $checks.filter(':checked').length;
    $('#tpl-check-all').prop('checked', allChecked);
  }

  $('#tpl-check-all').on('change', function () {
    interactiveChecks().prop('checked', $(this).is(':checked'));
    updateActionButtons();
    updateTotalAmount();
  });

  $(document).on('change', '.tpl-item-check:not(:disabled)', function () {
    updateCheckAll();
    updateActionButtons();
    updateTotalAmount();
  });

  function collectSelectedRecordIds() {
    var orderItemIds = [];
    var expensePaymentIds = [];

    selectedChecks().each(function () {
      var $row = $(this).closest('.tpl-body-row');
      var type = ($row.data('record-type') || 'order_item').toString();
      var ids = ($(this).val() || '').toString().split(',');
      ids.forEach(function (id) {
        if (!id) return;
        if (type === 'expense_payment') {
          expensePaymentIds.push(id);
        } else {
          orderItemIds.push(id);
        }
      });
    });

    return { orderItemIds: orderItemIds, expensePaymentIds: expensePaymentIds };
  }

  function hasSelectedRecordIds(ids) {
    return (ids.orderItemIds && ids.orderItemIds.length > 0) ||
      (ids.expensePaymentIds && ids.expensePaymentIds.length > 0);
  }

  function appendRecordIdInputs($container, ids) {
    (ids.orderItemIds || []).forEach(function (id) {
      $container.append($('<input>', { type: 'hidden', name: 'order_item_ids[]', value: id }));
    });
    (ids.expensePaymentIds || []).forEach(function (id) {
      $container.append($('<input>', { type: 'hidden', name: 'expense_payment_ids[]', value: id }));
    });
  }

  function fillHiddenIds(containerSelector, ids) {
    var $container = $(containerSelector);
    $container.empty();
    appendRecordIdInputs($container, ids || collectSelectedRecordIds());
  }

  function markRowsAsPrinted($rows) {
    $rows.each(function () {
      var $row = $(this);
      if ($row.attr('data-status') === 'completed') return;

      $row.attr('data-status', 'printed');
      $row.find('.tpl-item-check').prop('checked', true).prop('disabled', false);
      $row.find('.tpl-col-status').html(
        '<span class="tpl-status-badge tpl-status-printed">印刷済</span>'
      );
    });
    updateActionButtons();
    updateCheckAll();
    updateTotalAmount();
  }

  function uniqueValues(values) {
    var seen = {};
    var result = [];
    values.forEach(function (value) {
      if (!value || seen[value]) return;
      seen[value] = true;
      result.push(value);
    });
    return result;
  }

  function formatClickDate() {
    var now = new Date();
    var yyyy = now.getFullYear();
    var mm = String(now.getMonth() + 1).padStart(2, '0');
    var dd = String(now.getDate()).padStart(2, '0');
    return yyyy + '/' + mm + '/' + dd;
  }

  function buildCompleteSummary() {
    var $rows = selectedChecks().closest('.tpl-body-row');
    var count = $rows.length;
    var total = 0;
    var sources = [];

    $rows.each(function () {
      var $row = $(this);
      total += parseFloat($row.attr('data-amount') || 0) || 0;
      sources.push(($row.attr('data-source-bank') || '').trim());
    });

    var uniqueSources = uniqueValues(sources);

    return {
      count: count,
      dateLabel: formatClickDate(),
      sourceLabel: uniqueSources.length ? uniqueSources.join('、') : '-',
      amountLabel: Math.round(total).toLocaleString('ja-JP') + '円'
    };
  }

  function openCompleteModal() {
    var summary = buildCompleteSummary();
    if (!summary.count) return;

    $('#tpl-complete-count').text(summary.count + '件');
    $('#tpl-complete-date').text(summary.dateLabel);
    $('#tpl-complete-date-input').val(summary.dateLabel);
    $('#tpl-complete-source').text(summary.sourceLabel);
    $('#tpl-complete-amount').text(summary.amountLabel);
    $('#tpl-complete-modal').modal('show');
  }

  function downloadPdfBlob(blob, filename) {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename || '振込一覧表.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  function filenameFromDisposition(disposition) {
    if (!disposition) return '振込一覧表.pdf';
    var utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
      try { return decodeURIComponent(utf8Match[1]); } catch (e) { /* ignore */ }
    }
    var match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match && match[1]) return match[1].replace(/['"]/g, '');
    return '振込一覧表.pdf';
  }

  $('#tpl-print-btn').on('click', function () {
    if ($(this).prop('disabled')) return;

    var $printedRows = selectedChecks().closest('.tpl-body-row');
    if (!$printedRows.length) return;

    fillHiddenIds('#tpl-export-item-ids');
    var $form = $('#tpl-export-form');
    var $btn = $(this);
    $btn.prop('disabled', true);

    fetch($form.attr('action'), {
      method: 'POST',
      body: new FormData($form[0]),
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      var contentType = response.headers.get('content-type') || '';
      if (!response.ok || contentType.indexOf('application/pdf') === -1) {
        throw new Error('PDF export failed');
      }
      var filename = filenameFromDisposition(response.headers.get('content-disposition'));
      return response.blob().then(function (blob) {
        downloadPdfBlob(blob, filename);
        // Only update status after successful export
        markRowsAsPrinted($printedRows);
      });
    }).catch(function () {
      alert('PDFの生成に失敗しました。再度お試しください。');
    }).finally(function () {
      updateActionButtons();
    });
  });

  $('#tpl-complete-btn').on('click', function () {
    if ($(this).prop('disabled')) return;
    if (!hasSelectedRecordIds(collectSelectedRecordIds())) return;
    openCompleteModal();
  });

  $('#tpl-complete-confirm-btn').on('click', function () {
    var ids = collectSelectedRecordIds();
    if (!hasSelectedRecordIds(ids)) return;

    fillHiddenIds('#tpl-complete-item-ids', ids);
    $('#tpl-complete-date-input').val($('#tpl-complete-date').text());
    $('#tpl-complete-modal').modal('hide');
    $('#tpl-complete-form').trigger('submit');
  });

  function changeSourceSelect2Options() {
    return {
      width: '100%',
      theme: 'bootstrap',
      allowClear: false,
      dropdownParent: $('#tpl-change-source-modal'),
      language: {
        noResults: function () { return '見つかりません。'; },
        searching: function () { return '検索中...'; }
      }
    };
  }

  function initChangeSourceSelect2() {
    ['#tpl-change-source-company', '#tpl-change-source-bank'].forEach(function (selector) {
      var $el = $(selector);
      if (!$el.length) return;
      if ($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
      $el.select2(changeSourceSelect2Options());
    });
  }

  function refreshChangeSourceSelect2($el) {
    if ($el.hasClass('select2-hidden-accessible')) {
      $el.trigger('change.select2');
    }
  }

  function resetSourceBankSelect(placeholderText) {
    var $bank = $('#tpl-change-source-bank');
    $bank.prop('disabled', true)
         .empty()
         .append($('<option>', { value: '', text: placeholderText || '選択してください' }));
    refreshChangeSourceSelect2($bank);
  }

  function updateSourceConfirmButton() {
    var companyId = $('#tpl-change-source-company').val();
    var bankId = $('#tpl-change-source-bank').val();
    $('#tpl-change-source-confirm-btn').prop('disabled', !(companyId && bankId));
  }

  function loadSourceBanks(mainCompanyId) {
    var $bank = $('#tpl-change-source-bank');
    resetSourceBankSelect('選択してください');
    updateSourceConfirmButton();

    if (!mainCompanyId) return;

    $bank.prop('disabled', true);
    refreshChangeSourceSelect2($bank);

    $.ajax({
      url: '/transfer_print_lists/source_banks',
      method: 'GET',
      data: { main_company_id: mainCompanyId },
      success: function (res) {
        var banks = res.banks || [];
        resetSourceBankSelect('選択してください');
        banks.forEach(function (bank) {
          $bank.append($('<option>', { value: bank.id, text: bank.label }));
        });
        $bank.prop('disabled', false);
        refreshChangeSourceSelect2($bank);
        updateSourceConfirmButton();
      },
      error: function () {
        alert('振込元銀行の取得に失敗しました。');
        resetSourceBankSelect('選択してください');
        updateSourceConfirmButton();
      }
    });
  }

  function openChangeSourceModal() {
    if (!selectedChecks().length) return;

    $('#tpl-change-source-company').val('').trigger('change');
    updateSourceConfirmButton();
    $('#tpl-change-source-modal').modal('show');
  }

  function applySelectedSourceBank() {
    var $btn = $('#tpl-change-source-confirm-btn');
    var companyId = $('#tpl-change-source-company').val();
    var bankId = $('#tpl-change-source-bank').val();
    var ids = collectSelectedRecordIds();

    if ($btn.prop('disabled') || !companyId || !bankId || !hasSelectedRecordIds(ids)) return;

    $btn.prop('disabled', true);

    $.ajax({
      url: '/transfer_print_lists/apply_source_bank',
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: {
        main_company_id: companyId,
        bank_account_id: bankId,
        order_item_ids: ids.orderItemIds,
        expense_payment_ids: ids.expensePaymentIds
      },
      success: function (res) {
        if (!res.status || !res.bank) {
          alert((res && res.error) || '振込元銀行の適用に失敗しました。');
          updateSourceConfirmButton();
          return;
        }

        window.location.reload();
      },
      error: function (xhr) {
        var message = (xhr.responseJSON && xhr.responseJSON.error) || '振込元銀行の適用に失敗しました。';
        alert(message);
        updateSourceConfirmButton();
      }
    });
  }

  initChangeSourceSelect2();

  $('#tpl-change-source-btn').on('click', function () {
    if ($(this).prop('disabled')) return;
    openChangeSourceModal();
  });

  $('#tpl-change-source-company').on('change', function () {
    loadSourceBanks($(this).val());
  });

  $('#tpl-change-source-bank').on('change', function () {
    updateSourceConfirmButton();
  });

  $('#tpl-change-source-confirm-btn').on('click', function () {
    applySelectedSourceBank();
  });

  function isValidChangeDate(value) {
    if (!value) return false;
    if (!/^\d{4}\/\d{2}\/\d{2}$/.test(value)) return false;
    var parts = value.split('/');
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return date.getFullYear() === Number(parts[0]) &&
      date.getMonth() === Number(parts[1]) - 1 &&
      date.getDate() === Number(parts[2]);
  }

  function updateChangeDateConfirmButton() {
    var valid = isValidChangeDate($('#tpl-change-date-input').val());
    $('#tpl-change-date-confirm-btn').prop('disabled', !valid);
  }

  function initChangeDatePicker() {
    var $input = $('#tpl-change-date-input');
    if (!$input.length || $input.data('daterangepicker')) return;

    $input.daterangepicker({
      locale: window.ja_date_locale,
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
      showDropdowns: true,
      parentEl: 'body',
      startDate: formatClickDate()
    });

    $input.on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      updateChangeDateConfirmButton();
    });

    $input.on('cancel.daterangepicker', function () {
      $(this).val('');
      updateChangeDateConfirmButton();
    });
  }

  function openChangeDateModal() {
    var count = selectedChecks().length;
    if (!count) return;

    initChangeDatePicker();

    var today = formatClickDate();
    var $input = $('#tpl-change-date-input');
    $input.val(today);
    if ($input.data('daterangepicker')) {
      $input.data('daterangepicker').setStartDate(today);
    }

    $('#tpl-change-date-count').text('選択件数：' + count + '件');
    updateChangeDateConfirmButton();
    $('#tpl-change-date-modal').modal('show');
  }

  $('#tpl-change-date-btn').on('click', function () {
    if ($(this).prop('disabled')) return;
    openChangeDateModal();
  });

  $('#tpl-change-date-confirm-btn').on('click', function () {
    if ($(this).prop('disabled')) return;

    var ids = collectSelectedRecordIds();
    var paymentDate = $('#tpl-change-date-input').val();
    if (!hasSelectedRecordIds(ids) || !isValidChangeDate(paymentDate)) return;

    fillHiddenIds('#tpl-change-date-item-ids', ids);
    $('#tpl-change-date-payment-date').val(paymentDate);
    $('#tpl-change-date-modal').modal('hide');
    $('#tpl-change-date-form').trigger('submit');
  });

  function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : value).html();
  }

  function buildPartnerBankCard(bank, selectedId) {
    var checked = String(bank.id) === String(selectedId) || (!selectedId && bank.applying);
    var badge = bank.applying
      ? '<span class="tpl-source-bank-badge">適用中</span>'
      : '';

    return (
      '<label class="tpl-source-bank-card' + (checked ? ' is-selected' : '') + '" data-account-id="' + bank.id + '">' +
        '<input type="radio" class="tpl-source-bank-radio" name="tpl_source_bank_account_id" value="' + bank.id + '"' + (checked ? ' checked' : '') + '>' +
        '<div class="tpl-source-bank-card-body">' +
          badge +
          '<div class="tpl-source-bank-row"><span class="tpl-source-bank-label">銀行名</span><span class="tpl-source-bank-sep">：</span><span class="tpl-source-bank-value">' + escapeHtml(bank.bank_name) + '</span></div>' +
          '<div class="tpl-source-bank-row"><span class="tpl-source-bank-label">支店名</span><span class="tpl-source-bank-sep">：</span><span class="tpl-source-bank-value">' + escapeHtml(bank.branch_name) + '</span></div>' +
          '<div class="tpl-source-bank-row"><span class="tpl-source-bank-label">普通・当座</span><span class="tpl-source-bank-sep">：</span><span class="tpl-source-bank-value">' + escapeHtml(bank.account_type) + '</span></div>' +
          '<div class="tpl-source-bank-row"><span class="tpl-source-bank-label">口座番号</span><span class="tpl-source-bank-sep">：</span><span class="tpl-source-bank-value">' + escapeHtml(bank.account_number) + '</span></div>' +
          '<div class="tpl-source-bank-row"><span class="tpl-source-bank-label">振込名（カナ）</span><span class="tpl-source-bank-sep">：</span><span class="tpl-source-bank-value">' + escapeHtml(bank.holder_name_kana) + '</span></div>' +
        '</div>' +
      '</label>'
    );
  }

  function setPartnerBankModalEmpty($modal, isEmpty) {
    $modal.toggleClass('is-empty', !!isEmpty);
    $modal.find('.tpl-source-bank-dialog').toggleClass('modal-lg', !isEmpty);
    $modal.find('.tpl-source-bank-footer-default').toggleClass('d-none', !!isEmpty);
    $modal.find('.tpl-source-bank-footer-empty').toggleClass('d-none', !isEmpty);
  }

  function openPartnerBankModal($trigger) {
    var companyId = $trigger.data('company-id');
    var selectedBankId = $trigger.data('selected-bank-id');
    var companyEditUrl = $trigger.attr('data-company-edit-url') ||
      (companyId ? '/companies/' + companyId + '/edit#bank_data' : '');
    var $row = $trigger.closest('.tpl-body-row');
    var $list = $('#tpl-source-bank-list');
    var $modal = $('#tpl-source-bank-apply-modal');
    var $registerBtn = $('#tpl-source-bank-register-btn');

    $list.empty();
    setPartnerBankModalEmpty($modal, false);
    $modal.data('company-id', companyId);
    $modal.data('selected-bank-id', selectedBankId || '');
    $modal.data('triggerEl', $trigger.get(0));
    $modal.data('rowEl', $row.get(0));
    $modal.data('banksById', {});
    $registerBtn
      .attr('href', companyEditUrl || '#')
      .attr('aria-disabled', companyEditUrl ? 'false' : 'true')
      .toggleClass('disabled', !companyEditUrl);

    $.ajax({
      url: '/transfer_print_lists/partner_banks',
      method: 'GET',
      data: {
        company_id: companyId,
        selected_bank_id: selectedBankId || ''
      },
      success: function (res) {
        var banks = res.banks || [];
        var banksById = {};
        banks.forEach(function (bank) {
          banksById[bank.id] = bank;
        });
        $modal.data('banksById', banksById);
        setPartnerBankModalEmpty($modal, !banks.length);

        if (banks.length) {
          var selectedId = selectedBankId || (banks.find(function (b) { return b.applying; }) || banks[0]).id;
          banks.forEach(function (bank) {
            $list.append(buildPartnerBankCard(bank, selectedId));
          });
        }
        $modal.modal('show');
      },
      error: function (xhr) {
        var message = (xhr.responseJSON && xhr.responseJSON.error) || '口座情報の取得に失敗しました。';
        alert(message);
      }
    });
  }

  function applySelectedPartnerBankToRow() {
    var $modal = $('#tpl-source-bank-apply-modal');
    var $btn = $('#tpl-source-bank-save-btn');
    var rowEl = $modal.data('rowEl');
    var triggerEl = $modal.data('triggerEl');
    var banksById = $modal.data('banksById') || {};
    var selectedId = $modal.find('.tpl-source-bank-radio:checked').val();
    var bank = banksById[selectedId];
    var $row = rowEl ? $(rowEl) : $();
    var recordType = ($row.data('record-type') || 'order_item').toString();
    var recordIds = ($row.data('record-ids') || '').toString();

    if (!$row.length || !bank || !recordIds) return;
    if ($btn.prop('disabled')) return;

    $btn.prop('disabled', true);

    var data = { partner_company_bank_id: bank.id };
    if (recordType === 'expense_payment') {
      data.expense_payment_ids = recordIds;
    } else {
      data.order_item_ids = recordIds;
    }

    $.ajax({
      url: '/transfer_print_lists/apply_partner_bank',
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: data,
      success: function (res) {
        if (!res.status || !res.bank) {
          alert((res && res.error) || '口座の適用に失敗しました。');
          $btn.prop('disabled', false);
          return;
        }

        var applied = res.bank;
        $row.find('.tpl-bank-name').text(applied.bank_name || '-');
        $row.find('.tpl-branch-name').text(applied.branch_name || '-');
        $row.find('.tpl-account-type').text(applied.account_type || '-');
        $row.find('.tpl-account-number').text(applied.account_number || '-');
        $row.find('.tpl-recipient-name').text(applied.holder_name_kana || '-');
        $row.find('.tpl-source-account').text(applied.transfer_source_account_label || '-');

        if (triggerEl) {
          $(triggerEl).attr('data-selected-bank-id', applied.partner_company_bank_id)
                      .data('selected-bank-id', applied.partner_company_bank_id);
        }

        $modal.modal('hide');
        $btn.prop('disabled', false);
      },
      error: function (xhr) {
        var message = (xhr.responseJSON && xhr.responseJSON.error) || '口座の適用に失敗しました。';
        alert(message);
        $btn.prop('disabled', false);
      }
    });
  }

  $(document).on('click', '.tpl-change-partner-bank-btn', function () {
    openPartnerBankModal($(this));
  });

  $(document).on('change', '.tpl-source-bank-radio', function () {
    var $card = $(this).closest('.tpl-source-bank-card');
    $card.closest('.tpl-source-bank-list').find('.tpl-source-bank-card').removeClass('is-selected');
    $card.addClass('is-selected');
  });

  $('#tpl-source-bank-save-btn').on('click', function () {
    applySelectedPartnerBankToRow();
  });

  $(document).on('click', '.tpl-delete-btn', function () {
    var recordType = ($(this).data('record-type') || 'order_item').toString();
    var ids = ($(this).data('record-ids') || '').toString();
    if (!ids) return;
    if (!window.confirm('該当する確定済みの支払明細をすべて確定解除します。よろしいですか？')) return;

    var $container = $('#tpl-cancel-item-ids');
    $container.empty();
    var paramName = recordType === 'expense_payment' ? 'expense_payment_ids[]' : 'order_item_ids[]';
    ids.split(',').forEach(function (id) {
      if (id) $container.append($('<input>', { type: 'hidden', name: paramName, value: id }));
    });
    $('#tpl-cancel-form').trigger('submit');
  });

  // Avoid aria-hidden warning when closing modal while focus is still inside it
  $(document).on(
    'hide.bs.modal',
    '#tpl-source-bank-apply-modal, #tpl-change-source-modal, #tpl-change-date-modal, #tpl-complete-modal',
    function () {
      if (this.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }
  );

  updateActionButtons();
  updateCheckAll();
  updateTotalAmount();
});
